import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DashboardService } from 'src/app/providers/dashboard/dashboard.service';
import { GeneralService } from 'src/app/providers/general/general.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';

declare let $: any;
@Component({
  selector: 'app-employee-id-card',
  templateUrl: './employee-id-card.component.html',
  styleUrls: ['./employee-id-card.component.scss'],
})
export class EmployeeIdCardComponent implements OnInit {
  @Output() childEvent = new EventEmitter<any>();
  @Input() data: any;
  idCardForm: FormGroup;
  result: any = [];
  bpList: any;
  gpId: number;
  submitted: boolean;
  loading: boolean;
  docsFile: any = [];
  emp;
  emp_id;
  constructor(
    private idcardService: DashboardService,
    private notifyService: NotificationService,
    private httpGen: GeneralService
  ) {}

  get idErrMsg(): any {
    return this.idCardForm.controls;
  }
  
  ngOnInit(): void {
    this.formField();
    this.getEmpIdCardDetails();
    this.getBloodGroups();
  }

  formField(): void {
    this.idCardForm = new FormGroup({
      emp_id: new FormControl('', Validators.required),
      username: new FormControl(''),
      number: new FormControl('', Validators.required),
      file: new FormControl('', Validators.required),
      blod_grp_id: new FormControl('', Validators.required),
    });
  }

  getEmpIdCardDetails(): void {
    this.idcardService.getEmoIdCard().subscribe((res) => {
      this.result = res;
      if (this.result.status == true) {
        this.idCardForm.patchValue({
          emp_id: this.result.data.id,
          username: this.result.data.username + ' - ' + this.result.data.name,
          number: this.result.data.mobile,
        });
      } else {
      }
    });
  }

  searchEmp(): void {
    if (!this.emp) {
      this.notifyService.showError('Please Enter Employee ID', 'Info!');
      return;
    }
    this.httpGen.searchEmployee(this.emp).subscribe((res) => {
      if (res.status) {
        this.emp = res.data[0].username + '-' + res.data[0].name;
        this.emp_id = res.data[0].id;
        // this.childEvent.emit({emp_id: this.emp_id});
      } else {
        this.emp = '';
        this.emp_id = '';
        this.notifyService.showError(res.msg, 'Error!');
      }
    });
  }

  closeModal(): void {
    this.submitted = false;
    $('#employee_idcard').modal('hide');
    this.idCardForm.get('file').reset();
    this.idCardForm.get('blod_grp_id').reset();
    this.idCardForm.get('number').reset();
  }

  getBloodGroups(): void {
    this.gpId = 7;
    this.idcardService.getOptions(this.gpId).subscribe((res) => {
      this.result = res;
      this.bpList = this.result.data;
    });
  }

  onFileChange(event): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.docsFile = file;
    }
  }

  submitIdCard(): void {
    this.submitted = true;
    if (this.idCardForm.invalid) {
      return;
    }
    const empIdCardData = new FormData();
    empIdCardData.append('emp_id', this.idCardForm.get('emp_id').value);
    empIdCardData.append('number', this.idCardForm.get('number').value);
    empIdCardData.append(
      'blod_grp_id',
      this.idCardForm.get('blod_grp_id').value
    );
    empIdCardData.append('source', 'WEB');
    empIdCardData.append('file', this.docsFile);

    this.loading = true;
    this.idcardService.addEmpIdCard(empIdCardData).subscribe(
      (res) => {
        this.result = res;
        this.submitted = false;
        this.loading = false;
        this.docsFile = '';
        if (this.result.status === true) {
          this.notifyService.showSuccess(this.result.msg, 'Success !');
          this.closeModal();
          this.childEvent.emit({ isAdd: true });
        } else {
          this.idCardForm.get('file').reset();
          this.idCardForm.get('blod_grp_id').reset();
          this.idCardForm.get('number').reset();
          this.notifyService.showError(this.result.msg, 'Error !');
        }
      },
      (err) => {
        this.submitted = false;
        this.loading = false;
        this.notifyService.showError(err.error.msg, 'Error !');
      }
    );
  }
}
